


















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { EVENTS } from '../../bus/events.const';

@Component
export default class SimplePanel extends Vue {
  @Prop({ required: true })
  panelId: string;

  @Prop({ default: 'vertical' })
  layoutDirection: 'vertical' | 'horizontal';

  @Prop({ default: false })
  collapsible: boolean;

  @Prop({ required: true })
  collapsed: boolean;

  get directionClass() {
    return 'ebx-simple-panel--' + this.layoutDirection;
  }

  mounted() {
    if (this.collapsible) {
      this.$x.emit(EVENTS.QuantumEntanglement, this.panelId);
    }
  }
}
